import { Alert } from 'omakase';
import { FunctionComponent } from 'react';
import { core } from '@tock/coretypes';
import { deliveryServiceProviderDisplayName } from '@tock/shared/utils/offerings';

interface InstructionProps {
  ticketTypeVariety: core.TicketType.Variety;
  deliveryServiceProvider: core.DeliveryServiceProvider;
  reserveShippingTime: boolean;
  businessName: string;
}

const TicketTypeVarietySpecificInstructions: FunctionComponent<InstructionProps> = ({
  ticketTypeVariety,
  deliveryServiceProvider,
  reserveShippingTime,
  businessName,
}) => {
  switch (ticketTypeVariety) {
    case 'ORDER_PICKUP':
      return (
        <Alert severity="info">
          You're checking out for a pickup order. Please plan to arrive at {businessName} at the
          time you selected to pick up your order.
        </Alert>
      );
    case 'ORDER_DELIVERY':
      if (reserveShippingTime) {
        return null;
      }
      if (deliveryServiceProvider !== 'INTERNAL') {
        return (
          <Alert severity="info">
            You’re checking out for an order delivered via{' '}
            {deliveryServiceProviderDisplayName(deliveryServiceProvider)} courier. Delivery times
            are an estimate, and the driver will contact you at the phone number provided when your
            order arrives. Orders over $100 will require a signature.
          </Alert>
        );
      }
      return (
        <Alert severity="info">
          You're checking out for a delivery order. Delivery times are an estimate, and drivers will
          text you at the phone number you provided when your order arrives.
        </Alert>
      );
    default:
      return null;
  }
};

export default TicketTypeVarietySpecificInstructions;
